import { render, staticRenderFns } from "./StatusChooser.vue?vue&type=template&id=09a84d0f&scoped=true&"
import script from "./StatusChooser.vue?vue&type=script&lang=js&"
export * from "./StatusChooser.vue?vue&type=script&lang=js&"
import style0 from "./StatusChooser.vue?vue&type=style&index=0&id=09a84d0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a84d0f",
  null
  
)

export default component.exports